import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type { IntlService } from 'ember-intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import type { ForcModelPojo } from 'parog-web/components/forc/abstract/journal-event-based-component';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import BaseConsultForm from 'parog-web/components/mici/base-consult-form';
import RchSurveyFilledJournalEvent from 'parog-web/models/rch-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

export default class MiciRchSurveyConsultForm extends CrudJournalEventBaseComponent<RchSurveyFilledJournalEvent> {
  static override fullComponentId = 'mici/rch-survey-consult-form';
  static override journalEventClass = RchSurveyFilledJournalEvent;

  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;

  override get forcDisplayName(): string {
    if (this.session.medic) {
      return 'Questionnaire RCH';
    }
    return 'Symptômes';
  }

  get sections(): Array<string> {
    return RchSurveyFilledJournalEvent.sections;
  }

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  override retrieveModel(): ForcModelPojo {
    const model = super.retrieveModel();

    if (!model['immediateStoolUrgency']) {
      model['immediateStoolUrgency'] = '0';
    }
    return model;
  }

  <template>
    <BaseConsultForm @forcComponent={{this}}>
      <:additionalInfoMessage>
        {{#if this.session.medic}}
          <div class='ui info message visible' data-test-rch-info>
            Ce questionnaire PRO a été élaboré par le Groupe d’Etude
            Thérapeutique des Affections Inflammatoires du Tube Digestif
            (GETAID), société savante spécialisée dans les essais de stratégie
            thérapeutique dans le domaine des MICI.
            <br />Ce questionnaire permet de
            <b>détecter précocement une dégradation de l’état de santé du
              patient</b>
            à partir du delta (+4 points définis empiriquement) par rapport au
            questionnaire précédent renseigné par le patient (N-1).
            <br />Il permet également de
            <b>rendre compte d’une poussée de la pathologie</b>
            à travers des alertes dédiées pour certains items : nombre de selles
            (+3 par rapport à N-1), fièvre (&gt;38°), perte de poids (-2kg sur
            les 3 derniers mois).
          </div>
        {{/if}}
      </:additionalInfoMessage>
    </BaseConsultForm>
  </template>
}
